import React from "react";
import thousandsFormat from "@/modules/thousandsFormat";

import StreamingQualityButton from "../StreamingQualityButton";

import { assetImg } from "@/modules/moduleImporter";
import { hasHDStreaming } from "@/modules/videoQuality";
import { ILanguageType, IGameType, IUserdataType, IVideoQualityProps } from "@/types/GlobalTypes";

import "./index.scss";

interface IProps extends IVideoQualityProps {
	lang: ILanguageType;
	activeGame: IGameType;
	userdata: IUserdataType;

	enableStreaming: boolean;
	updateSettings: (e: React.MouseEvent) => void;
}

//function Desc Heading Content
function fDHC(heading: string, content: string, border = true) {
	return (
		content ? (
			<div className={border ? "border-bottom" : ""}>
				<div className="desc-heading">
					{ heading }
				</div>
				<div className="desc-content">
					{ content }
				</div>
			</div>
		) : (
			<div className={border ? "border-bottom" : ""}>
				<div className="desc-heading nocontent">
					{ heading }
				</div>
			</div>
		)
	);
}

/**
 * For use in MaximizeGameV2
 */
export default class LeftSideButtons extends React.Component<IProps> {
	state = {
		showMinMax: false,
		showTableInfo: false,
	};
	
	toggleShowTableInfo() {
		this.setState({showMinMax: false, showTableInfo: !this.state.showTableInfo});
	}
	
	toggleMinMax() {
		this.setState({showMinMax: !this.state.showMinMax, showTableInfo: false});
	}
	
	render() {
		const { activeGame, lang, userdata } = this.props;

		return (
			<div className="left-side-button-container">
				<button onClick={this.toggleShowTableInfo.bind(this)}>
					{/*<img src={this.icons["img_info.svg"]} alt="info" />*/}
					{assetImg("v2icons", "img_info.svg")}
					<div className="tooltip">
						{lang["txt_table_information"]}
					</div>
				</button>
				
				<button onClick={this.toggleMinMax.bind(this)}>
					{/* <img src={this.icons["img_min_max.svg"]} alt="min max" /> */}
					{assetImg("v2icons", "img_min_max.svg")}
					<div className="tooltip">
						{lang["txt_bet_limit"]}
					</div>
				</button>

				<button
					name="Streaming"
					{...{prop: "streaming"}}
					onClick={this.props.updateSettings}
					>

				{
					this.props.enableStreaming ?
					assetImg("v2icons", "img_video_on.svg") :
					assetImg("v2icons", "img_video_off.svg")
					// <img src={this.icons["img_video_on.svg"]} alt="streaming on" /> :
					// <img src={this.icons["img_video_off.svg"]} alt="streaming off" />
				}
					<div className="tooltip">
						{lang["txt_toggle_streaming"]}
					</div>
				</button>
				
				
				{
					this.state.showTableInfo ? (
					<div className="table-information info">
						{ fDHC(lang["txt_table_name"], userdata.user.table) }
						{ /* fDHC(lang["txt_round_id"], periode) */ }
						{ /* shoePeriode ? fDHC(`${lang["txt_shoe"]}-${lang["txt_periode"]}`, shoePeriode) : null */ }
					</div>
					) : null
				}
				
				{
					this.state.showMinMax ? (
					<div className="table-information min-max">
						{ fDHC(lang["txt_bet_limit"], "") }
						{ fDHC(lang["txt_min_number"], thousandsFormat(activeGame.min, userdata.user.lang), false) }
						{ fDHC(lang["txt_max_number"], thousandsFormat(activeGame.max, userdata.user.lang)) }
						{ fDHC(lang["txt_min_50"], thousandsFormat(activeGame.min50, userdata.user.lang), false) }
						{ fDHC(lang["txt_max_50"], thousandsFormat(activeGame.max50, userdata.user.lang)) }
						{ fDHC(lang["txt_detail"], "1K = " + thousandsFormat(1000, userdata.user.lang)) }
					</div>
					) : null
				}

				{
					activeGame.maximised &&
					userdata.user.enableStreaming &&
					hasHDStreaming(activeGame) ? (
					<StreamingQualityButton
						quality={this.props.videoQuality}
						changeQuality={this.props.changeVideoQuality}
						txtTooltip={lang["txt_popup_streaming_quality"]}
						pcode={activeGame.pcode} />
						) : null
				}

			</div>
		);
	}
}